import { UI_ACTIONS } from '../types';

export const updateCurrentlyOpenDropdownOverflowButtonId = (id?: string) => ({
  type: UI_ACTIONS.UPDATE_CURRENTLY_OPEN_DROPDOWN_OVERFLOW_BUTTON_ID,
  payload: id,
});
